export { default } from './ActionButton.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Notification/ActionButton/index.js